import React from "react";
import { ActivityListItem } from "./ActivityListItem";
import { TicketActivity } from "../../../api/services";
import { TicketIcon } from "../../../icons";
import { ActivitySummaryCell } from "./ActivitySummaryCell";

export const TicketActivityItem: React.FC<{
  activity: TicketActivity;
}> = ({ activity }) => {
  const { activityDttm, ticketInfo } = activity;
  const { name } = ticketInfo;
  return (
    <ActivityListItem
      icon={<TicketIcon />}
      title={name}
      activityDttm={activityDttm}
    />
  );
};

export const TicketActivitySummaryCell: React.FC<{
  activity: TicketActivity;
  isGrey: boolean;
}> = ({ activity, isGrey }) => {
  const { ticketInfo } = activity;
  const { name } = ticketInfo;
  return (
    <ActivitySummaryCell isGrey={isGrey} icon={<TicketIcon />} summary={name} />
  );
};
